import React from 'react';
import { connect } from 'react-redux';
import { AppointmentCTAProps } from 'util/Props';
import AppointmentCTAView from 'components/AppointmentCTA';

class AppointmentCTA extends React.Component {
    render() {
        return <AppointmentCTAView {...this.props} />;
    }
}

AppointmentCTA.propTypes = AppointmentCTAProps;
const mapStateToProps = state => {
    const { globalState, PDPState } = state;
    return {
        userStore: globalState.userStore || globalState.stores[0],
        fetchInventoryMsgURL: globalState.fetchInventoryMsgURL ? globalState.fetchInventoryMsgURL : '',
        inventoryMsg: PDPState ? PDPState.inventoryMsg : ''
    };
};
export default connect(mapStateToProps)(AppointmentCTA);
